import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AddCategoriesLayer from "../components/AddCategoriesLayer";

const AddCategoriesPage = () => {
  return (
    <MasterLayout>
      <AddCategoriesLayer />
    </MasterLayout>
  );
};

export default AddCategoriesPage;
